import React, { useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import Icon from "theme/components/atoms/Icon";
import FrontCommerceIcon from "theme/components/atoms/FrontCommerceIcon";
import EditorialToolbox from "theme/components/molecules/EditorialToolbox";
import EditorialToolboxProvider from "theme/components/molecules/EditorialToolbox/EditorialToolboxProvider";

const messages = defineMessages({
  closedTitle: {
    id: "modules.MagicButton.closeTitle",
    defaultMessage: "Open the editorial toolbox",
  },
  openedTitle: {
    id: "modules.MagicButton.openedTitle",
    defaultMessage: "Close the editorial toolbox",
  },
});

const MagicButton = (props) => {
  const intl = useIntl();
  const [isOpened, setIsOpened] = useState(false);

  return (
    <EditorialToolboxProvider
      isPreviewModeEnabled={props.isPreviewModeEnabled}
      isXRayModeEnabled={props.isXRayModeEnabled}
    >
      <div className="magic-button">
        {isOpened && (
          <div className="magic-button__toolbox">
            <EditorialToolbox />
          </div>
        )}
        <div className="magic-button__button-wrapper">
          <button
            className="magic-button__button"
            onClick={() => {
              setIsOpened(!isOpened);
            }}
            title={
              isOpened
                ? intl.formatMessage(messages.openedTitle)
                : intl.formatMessage(messages.closedTitle)
            }
          >
            {isOpened ? (
              <Icon icon="cross" size="big" title="" />
            ) : (
              <FrontCommerceIcon size={32} />
            )}
          </button>
        </div>
      </div>
    </EditorialToolboxProvider>
  );
};

export default MagicButton;
